export default {
  dateScenarioShifts: [],
};
